<template>
  <div class="sickdaystatistics__report__view">
    <div class="reports__subheader">
      <period-panel
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @dateFrom="(value) => (this.dateFrom = value)"
        @dateTo="(value) => (this.dateTo = value)"
      >
      </period-panel>

      <group-panel @groupId="(value) => (groupId = value)" :addDefault="true">
      </group-panel>

      <employees-panel
        @employeeId="(value) => (employeeId = value)"
        v-if="false"
      >
      </employees-panel>

      <submit-panel @submit="performLookup"> </submit-panel>
      <div
        class="reports__panel--submit"
        v-if="monthReportForPeriod.length > 0"
      >
        <b-button class="button is-primary" @click="openSidebarAsync()">
          Filtrere medarbejdere
        </b-button>
      </div>
    </div>

    <b-table
      :data="monthReportForPeriod"
      :loading="loading"
      default-sort="number"
      hoverable
    >
      <b-table-column
        field="number"
        label="Ins. nr."
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.number }}
      </b-table-column>

      <b-table-column field="name" label="Inseminør" v-slot="props" sortable>
        {{ props.row.name }}
      </b-table-column>

      <b-table-column
        field="absence"
        label="Fravær"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.absence }}
      </b-table-column>

      <b-table-column
        field="sickReplacement"
        label="Sygdomsafløsning"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.sickReplacement }}
      </b-table-column>

      <b-table-column
        field="sickWork"
        label="Sygedag arbejdsrelateret"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.sickWork }}
      </b-table-column>

      <b-table-column
        field="sick"
        label="Sygedag"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.sick }}
      </b-table-column>
      <b-table-column
        field="sickDayChild"
        label="Barnets første sygedag"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.sickDayChild }}
      </b-table-column>
      <b-table-column
        field="maternity"
        label="Barsel/Orlov betalt af viking"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.maternity }}
      </b-table-column>
      <b-table-column
        field="maternityNotPaid"
        label="Orlov ikke betalt af viking"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ props.row.maternityNotPaid }}
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from "@/enums/APISTATE";
import PeriodPanel from "@/components/report/PeriodPanel.vue";
import EmployeesPanel from "@/components/report/EmployeesPanel.vue";
import GroupPanel from "@/components/report/GroupPanel.vue";
import SubmitPanel from "@/components/report/SubmitPanel.vue";

export default {
  name: "absencestatistics-report-view",
  components: { PeriodPanel, SubmitPanel, EmployeesPanel, GroupPanel },
  data: () => ({
    dateFrom: undefined,
    dateTo: undefined,
    groupId: undefined,
    employeeId: undefined,
  }),
  async mounted() {
    this.dateFrom = new Date(new Date().getFullYear(), 0, 1);
    this.dateTo = new Date(new Date().getFullYear(), 11, 31);
  },
  methods: {
    ...mapActions("reportStore", [
      "getAbsenceStatisticsForPeriod",
      "setAbsenceStatisticsForPeriod",
    ]),
    ...mapActions("generalStatisticsFilteringSidebar", [
      "sidebarOpenAsync",
      "setIsOpen",
      "setGroupMembers",
      "setFilter",
    ]),
    async performLookup() {
      const dto = {
        startDate: this.dateFrom,
        endDate: this.dateTo,
        forGroup: this.groupId,
        forUser: this.employeeId,
      };
      await this.getAbsenceStatisticsForPeriod(dto);
    },
    async openSidebarAsync() {
      this.setGroupMembers(this.monthReportForPeriod);
      await this.sidebarOpenAsync()
        .then(async (response) => {
          if (response.action === "update") {
            await this.setAbsenceStatisticsForPeriod(
              response.markedGroupMembers
            );
          }
        })
        .catch((error) => console.error(error));
    },
  },
  computed: {
    ...mapGetters("reportStore", [
      "monthReportForPeriodApiState",
      "monthReportForPeriod",
    ]),
    loading() {
      return this.monthReportForPeriodApiState === APISTATE.LOADING;
    },
    validated() {
      return this.dateFrom && this.dateTo && this.groupId && this.employeeId;
    },
  },
};
</script>
